<div class="box">
  <div class="modal-header">
    <button
      type="button"
      class="close pull-right"
      title="{{ 'CLOSE' | translate }}"
      [attr.aria-label]="'CLOSE' | translate"
      (click)="hide()"
    ></button>
  </div>

  <div class="modal-body">
    <div class="image-block">
      <p class="image-block-image"></p>
    </div>

    <section class="modal-body__content">
      <p class="title">{{ errorTitle }}</p>

      <p class="sub-title">{{ errorData.message }}</p>

      <div class="error-data">
        @for (title of formatedErrorData; track title) {
          <p>{{ title }}</p>
        }
      </div>
    </section>
  </div>
</div>
